import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogueComponent } from 'src/app/components/confirmation-dialogue/confirmation-dialogue.component';
import { CameraServerService } from '../camera-server.service';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AppConstants } from 'src/app/shared/app-constants';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ConfigService } from 'src/app/services/config.service';
import { MatDialog } from '@angular/material/dialog';
import { SiteCamLiveViewsComponent } from '../dialogs/site-cam-live-views/site-cam-live-views.component';

export interface TableElement {
  unique_id: number;
  camera_id: string;
  camera_name: string;
  camera_type: string;
  site_name: string;
  PTZ: string;
  active: boolean;
  analytic_name: string;
}

@Component({
  selector: 'app-camera-list',
  templateUrl: './camera-list.component.html',
  styleUrls: ['./camera-list.component.scss']
,
  standalone: false
})
export class CameraListComponent implements OnInit {

  searchTerms = new Subject<string>();
  searchCameraFilterValue: string = ''
  loading: boolean = false;
  displayedColumns: string[] = ['unique_id', 'camera_name', 'camera_type', 'active', 'analytic_name', 'connected', 'action'];
  dataSource = new MatTableDataSource<TableElement>([]);
  dataSourceArray: any;
  selection = new SelectionModel<TableElement>(true, []);
  totalRecords = 0;
  pageSize = 10;
  pageIndex = 0;
  selectRow: any = [];
  selectAllRow: any = [];

  isLoadingResults = true;
  isRateLimitReached = false;
  editCameraConfig = false;
  cameraServerDetails: any = [];
  isLiveViewEnabled: boolean = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private router: Router,
    private ngbModalService: NgbModal,
    private camService: CameraServerService,
    private toastr: ToastrService,
    public spinner: SpinnerService,
    private authService: AuthenticationService,
    public dialog: MatDialog,
    public configService: ConfigService
  ) { }

  ngOnInit(): void {
    const cameraSearchValue = localStorage.getItem("cameraSearchFilterVal") || '';
    this.searchCameraFilterValue = cameraSearchValue || '';
    this.isLiveViewEnabled = this.configService.isFeatureEnabled('liveView');
    this.checkCameraServerOldOrNew();
    this.getCurrentUser();
    this.applyCameraFilter();
  }
  ngAfterViewInit() {
    // this.isLoadingResults = true;
    this.dataSource.paginator = this.paginator;
    // this.pageIndex = this.paginator.pageIndex;
    // this.pageSize = this.paginator.pageSize;
    // this.sort.active
    // this.dataSource.sort = this.sort;
    // this.sort.direction
    // this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
  }

  getCurrentUser() {
    const currentUser = this.authService.currentUserValue;
    if (currentUser) {
      if (currentUser['privileges'] && currentUser['privileges'].length > 0) {
        for (let i = 0; i < currentUser['privileges'].length; i++) {
          if (currentUser['privileges'][i].toLowerCase() === 'edit camera configuration') {
            this.editCameraConfig = true;
          }
        }
      }
    }
  }

  getPagedData(pageSIze: any, PageIndex: any, searchvalue: string) {
    this.spinner.activate();
    this.loading = true;
    this.camService.searchCam(searchvalue).subscribe((response: any) => {
      if (response && response.success) {
        this.spinner.deactivate();
        this.loading = false;
        let newResponseData = response?.data?.cams;
        const newCheckedCameraDetails = newResponseData?.map((item: any, index: any) => {
          this.cameraServerDetails?.map((cItem: any) => {
            if (cItem.platform == 'NEW_CAMERA_SERVER' && cItem?.potentialId == item?.potentialId && !item['isNewCamServer']) {
              item['isNewCamServer'] = true;
            }
          });
          return item;
        });
        this.dataSource = new MatTableDataSource<any>(newCheckedCameraDetails || []);
        this.dataSource.paginator = this.paginator;
        this.totalRecords = response?.data?.totalRecords;
        this.sort.active = "ui_created_date";
        this.sort.start = "desc";
        this.dataSource.sort = this.sort;
        this.selection = new SelectionModel<TableElement>(true, []);
      } else {
        this.spinner.deactivate();
        this.loading = false;
        this.toastr.error(response?.data?.message)
      }
    }, err => {
      this.loading = false;
      this.spinner.deactivate();
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
      }
    });
    // this.dataSource = new MatTableDataSource<TableElement>(Camera_Data);
    // this.dataSource.paginator = this.paginator;
    // this.totalRecords = this.dataSource.data.length;
    // this.dataSource.sort = this.sort;
  }

  /** Check the Camera server is is Old camera server or New Camera server */
  checkCameraServerOldOrNew() {
    this.spinner.activate();
    this.loading = true;
    this.camService.checkPlateForm().subscribe((response: any) => {
      if (response && response.success) {
        this.spinner.deactivate();
        this.loading = false;
        this.cameraServerDetails = response?.data;
        this.getPagedData(this.pageSize, this.pageIndex, this.searchCameraFilterValue);
      } else {
        this.spinner.deactivate();
        this.loading = false;
        this.toastr.error(response?.message || AppConstants.defaultErrorMessage);
      }
    }, err => {
      this.loading = false;
      this.spinner.deactivate();
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
      }
    });
  }

  /**Search functionality */
  applyCameraFilter() {
    this.searchTerms
      .pipe(debounceTime(1500), distinctUntilChanged())
      .subscribe((searchVal) => {
        localStorage.setItem("cameraSearchFilterVal", this.searchCameraFilterValue);
        if (searchVal.length >= 3) {
          this.getPagedData(
            this.pageSize,
            0,
            this.searchCameraFilterValue
          );
        } else if (searchVal.length == 0) {
          this.getPagedData(
            this.pageSize,
            this.pageIndex,
            this.searchCameraFilterValue
          );
        }
      });
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  /** Function call when user clear the search filter value. */
  clearSearchFilter() {
    this.searchCameraFilterValue = '';
    localStorage.setItem("cameraSearchFilterVal", '');
    if (this.searchCameraFilterValue == '') {
      this.getPagedData(
        this.pageSize,
        this.pageIndex,
        this.searchCameraFilterValue
      );
    }
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: TableElement): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.unique_id + 1}`;
  }

  // selectedCheckBoxRow(event: any, row: any) {
  //   event.stopPropagation();
  //   const newSelectedRow = this.selectRow;
  //   newSelectedRow.push(row)
  //   this.selectRow = newSelectedRow
  // }

  changePaging(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getPagedData(this.pageSize, this.pageIndex, this.searchCameraFilterValue);
    this.selectAllRow = [];
    this.selection.clear();
  }

  selectedRow(event: any, row: any) {
    event.stopPropagation();
    // this.router.navigate(["/camera-server/update-camera-list"])
  }

  editCamera(element: any) {
    localStorage.setItem("selectedTabCamera", '0');
    sessionStorage.setItem("camUniqueId", element.camUniqueId)
    sessionStorage.setItem("isAddCameraInSite", "false");
    sessionStorage.setItem("isEditfromSite", "false");
    sessionStorage.setItem("isCameraEdit", "true");
    this.router.navigate([`/camera-server/edit-camera-list/${element.camUniqueId}`])
  }

  removeCamera() {
    let popupData = {
      title: "Delete Confirmation",
      message: `Are you sure you want to delete these ${this.selection?.selected?.length} ${(this.selection?.selected?.length <= 1) ? 'camera?' : 'cameras?'}`,
      cancelBtnText: "No",
      confirmBtnText: "Yes"
    }
    let dialoge = this.ngbModalService.open(ConfirmationDialogueComponent);
    dialoge.componentInstance._data = popupData;
    dialoge.result.then(data => {
      if (data) {
        //this data return true if user click on Yes, and if No the return false
        this.spinner.activate();
        this.loading = true;
        this.selection?.selected?.map((item: any) => {
          return this.camService.deleteCam(item.camUniqueId).subscribe((response: any) => {
            if (response && response.success) {
              this.spinner.deactivate();
              this.loading = false;
              this.toastr.success("Camera deleted successfully");
              this.selection.clear();
              this.getPagedData(this.pageSize, this.pageIndex, this.searchCameraFilterValue);
            } else {
              this.spinner.deactivate();
              this.loading = false;
              this.toastr.error(response?.messages[0] || AppConstants.defaultErrorMessage);
            }
          }, (err) => {
            this.spinner.deactivate();
            if (err && err.error && err.error.message && err.error.message.length > 0) {
              this.toastr.error(err.error.message, 'Error');
            } else {
              this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
            }
          })
        })
      }
    })
  }

  /** Show the live view cameras */
  liveView(event: any, element: any) {
    const dialogRef = this.dialog.open(SiteCamLiveViewsComponent, {
      data: { vtigerPotentialId: element.potentialId, isSingleCam: [element] },
      disableClose: true,
      width: '50%',
      height: '80%',
      panelClass: 'full-screen-modal'
    });
  }

}
